import React, { useState, useEffect } from 'react';
import './MaintenancePage.css';

const FUNNY_MESSAGES = [
  'Sewing new styles... ✂️',
  'Threading the needle... 🧵',
  'Cutting fabric for your next favorite outfit...',
  'Stitching something fabulous... 👕',
  'Our tailors are busy at work!',
  'Ironing out the wrinkles... 👔',
  'Adding the final buttons... 🔘',
  'Measuring twice, cutting once!',
];

const MaintenancePage = () => {
  const [funnyMsg, setFunnyMsg] = useState(FUNNY_MESSAGES[0]);

  useEffect(() => {
    const i = setInterval(() => {
      setFunnyMsg(prev => {
        const idx = FUNNY_MESSAGES.indexOf(prev);
        return FUNNY_MESSAGES[(idx + 1) % FUNNY_MESSAGES.length];
      });
    }, 3000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="maintenance-page">
      <div className="maintenance-bg">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
        {/* Floating fabric pieces */}
        <div className="fabric-piece fabric-1">👕</div>
        <div className="fabric-piece fabric-2">🧵</div>
        <div className="fabric-piece fabric-3">✂️</div>
        <div className="fabric-piece fabric-4">👔</div>
        <div className="fabric-piece fabric-5">🪡</div>
      </div>

      <div className="maintenance-content">
        {/* Sewing workshop area */}
        <div className="sewing-workshop">
          <div className="workshop-table">
            <div className="shirt-being-sewn">
              <span className="shirt-emoji">👕</span>
              <div className="stitch-line stitch-1"></div>
              <div className="stitch-line stitch-2"></div>
              <div className="stitch-line stitch-3"></div>
            </div>
            <div className="sewing-tools">
              <div className="tool scissors">
                <i className="fas fa-scissors"></i>
              </div>
              <div className="tool needle">
                <span className="needle-icon">🪡</span>
              </div>
              <div className="tool thread">
                <span className="thread-icon">🧵</span>
              </div>
            </div>
          </div>
        </div>

        <div className="maintenance-icon-wrapper">
          <div className="gear gear-1">
            <i className="fas fa-cog"></i>
          </div>
          <div className="gear gear-2">
            <i className="fas fa-cog"></i>
          </div>
          <div className="gear gear-3">
            <i className="fas fa-tools"></i>
          </div>
        </div>

        <h1 className="maintenance-title">
          <span className="title-line">Coming Soon</span>
        </h1>
        <p className="maintenance-subtitle">Coming soon</p>
        <p className="maintenance-message">
          Our tailors are busy stitching new collections for you!
          <br />
          We're cutting, sewing & adding the final touches. Check back soon!
        </p>

        <div className="maintenance-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <p className="progress-text funny-msg">{funnyMsg}</p>
        </div>

        <div className="maintenance-footer">
          <p>Thank you for your patience!</p>
          <p className="footer-fun">(Our sewing machines are working overtime! 🪡)</p>
          <div className="sparkles">
            <span className="sparkle">✨</span>
            <span className="sparkle">👕</span>
            <span className="sparkle">✨</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
